import {
  Component,
  Input,
  OnChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ApexOptions, ChartComponent } from 'ng-apexcharts';

@Component({
  selector: 'app-trend-histogram',
  templateUrl: './trend-histogram.component.html',
  styleUrls: ['../../../shared/analytics//analytics.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TrendHistogram implements OnChanges {
  @ViewChild('chart') chart: ChartComponent;

  @Input() categories: number[] = [];

  @Input() chartName: string = '';

  chartOptions: ApexOptions & { markers?: any } = {
    series: [],
    chart: {
      height: 350,
      type: 'line',
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    title: {
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      text: '',
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
      formatter: (value: number) => value.toLocaleString('en-US'),
    },
    markers: {
      size: 5,
    },
    xaxis: {
      categories: [],
      type: 'datetime',
    },
    yaxis: {
      labels: {
        formatter: (value: number) => value.toLocaleString('en-US'),
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
              },
            },
          },
        },
      },
    ],
  };

  ngOnChanges(): void {
    this.chartOptions = {
      ...this.chartOptions,
      series: [
        {
          data: this.categories,
          name: this.chartName,
        },
      ],
      title: {
        text: this.chartName,
        align: 'center',
      },
      xaxis: {
        type: 'datetime',
        categories: this.categories,
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            if (this.chartName.includes('%')) {
              return `${value.toLocaleString('en-US')}%`;
            }
            return value.toLocaleString('en-US');
          },
        },
      },
      dataLabels: {
        enabled: false,
        formatter: (value: number) => {
          if (this.chartName.includes('%')) {
            return `${value.toLocaleString('en-US')}%`;
          }
          return value.toLocaleString('en-US');
        },
      },
    };
  }
}
